"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ConfirmerContext: function() {
        return ConfirmerContext;
    },
    ConfirmerProvider: function() {
        return ConfirmerProvider;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _localisationeq1 = require("@equiem/localisation-eq1");
const _Modal = /*#__PURE__*/ _interop_require_wildcard(require("../components/Modal"));
const _AdminButton = require("../components/Button/AdminButton");
const _Button = require("../components/Button/Button");
const _ToastContext = require("../components/Toast/ToastContext");
const _ToastProvider = require("../components/Toast/ToastProvider");
const _Theme = require("./Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ConfirmerContext = /*#__PURE__*/ (0, _react.createContext)({
    withConfirmation: ()=>()=>undefined
});
const defaultVariant = "primary";
const ConfirmerProvider = (param)=>{
    let { children } = param;
    const { t } = (0, _localisationeq1.useTranslation)();
    const defaultCancelBtn = t("common.cancelNo");
    const defaultSize = "sm";
    const existingToastContext = (0, _react.useContext)(_ToastContext.ToastContext);
    const ConditionalToastProvider = existingToastContext.provided ? _react.Fragment : _ToastProvider.ToastProvider;
    const { isAdmin, spacers, breakpoints } = (0, _Theme.useTheme)();
    const [showModal, setShowModal] = (0, _react.useState)(false);
    const [handler, setHandler] = (0, _react.useState)();
    const [title, setTitle] = (0, _react.useState)("");
    const [msg, setMessage] = (0, _react.useState)("");
    const [variant, setVariant] = (0, _react.useState)(defaultVariant);
    const [confirmButtonText, setConfirmButtonText] = (0, _react.useState)("");
    const [intro, setIntro] = (0, _react.useState)();
    const [cancelButtonText, setCancelButtonText] = (0, _react.useState)(defaultCancelBtn);
    const [size, setSize] = (0, _react.useState)(defaultSize);
    const withConfirmation = (0, _react.useCallback)((input)=>{
        return ()=>{
            setMessage(input.message);
            setTitle(input.title);
            setConfirmButtonText(input.confirmButtonText);
            var _input_cancelButtonText;
            setCancelButtonText((_input_cancelButtonText = input.cancelButtonText) !== null && _input_cancelButtonText !== void 0 ? _input_cancelButtonText : defaultCancelBtn);
            setIntro(input.intro);
            setHandler(()=>input.onConfirm);
            var _input_confirmButtonVariant;
            setVariant((_input_confirmButtonVariant = input.confirmButtonVariant) !== null && _input_confirmButtonVariant !== void 0 ? _input_confirmButtonVariant : defaultVariant);
            setShowModal(true);
            var _input_size;
            setSize((_input_size = input.size) !== null && _input_size !== void 0 ? _input_size : defaultSize);
        };
    }, [
        defaultCancelBtn
    ]);
    const hideModal = (0, _react.useCallback)(()=>{
        setShowModal(false);
    }, []);
    const localHandler = (0, _react.useCallback)(()=>{
        if (handler != null) {
            handler();
        }
        hideModal();
    }, [
        handler,
        hideModal
    ]);
    return /*#__PURE__*/ _react.default.createElement(ConfirmerContext.Provider, {
        value: {
            withConfirmation
        }
    }, /*#__PURE__*/ _react.default.createElement(ConditionalToastProvider, null, /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, children, /*#__PURE__*/ _react.default.createElement(_Modal.Dialog, {
        title: title,
        show: showModal,
        onHide: hideModal,
        hideOnEsc: true,
        centered: true,
        withFooter: true,
        size: size,
        className: "confirm-modal",
        containerClassName: "confirm-modal-container",
        zIndex: 1020
    }, /*#__PURE__*/ _react.default.createElement(_Modal.Header, {
        closeButton: false,
        intro: intro,
        noBorder: true
    }), /*#__PURE__*/ _react.default.createElement(_Modal.Body, null, msg), /*#__PURE__*/ _react.default.createElement(_Modal.Footer, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "fba7066ddc62583b",
                [
                    spacers.s2,
                    breakpoints.md,
                    spacers.s2,
                    spacers.s2
                ]
            ]
        ]) + " " + "footer"
    }, isAdmin ? /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        size: "md",
        onClick: hideModal,
        className: "cancel",
        variant: "ghost"
    }, cancelButtonText) : /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        size: "md",
        onClick: hideModal,
        className: "cancel",
        variant: "secondary"
    }, cancelButtonText), isAdmin ? /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        onClick: localHandler,
        size: "md",
        className: "confirm",
        variant: variant
    }, confirmButtonText) : /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        onClick: localHandler,
        size: "md",
        className: "confirm",
        variant: "primary"
    }, confirmButtonText)))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "fba7066ddc62583b",
        dynamic: [
            spacers.s2,
            breakpoints.md,
            spacers.s2,
            spacers.s2
        ]
    }, ".footer.__jsx-style-dynamic-selector .cancel{margin-right:".concat(spacers.s2, "}@media(max-width:").concat(breakpoints.md, "px){.confirm-modal{max-width:unset!important;width:100vw!important;position:fixed!important;top:unset!important;left:0;right:0;bottom:0;-webkit-border-radius:").concat(spacers.s2, " ").concat(spacers.s2, " 0 0!important;-moz-border-radius:").concat(spacers.s2, " ").concat(spacers.s2, " 0 0!important;border-radius:").concat(spacers.s2, " ").concat(spacers.s2, " 0 0!important}}")))));
};

//# sourceMappingURL=ConfirmerContext.js.map